/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import React from 'react';
import GraphQlClient from '../../services/graphql/GraphQlClient';
import { Testimonials, TestimonialsProps } from './Testimonials';
import { ApolloProvider } from '@apollo/client';

export const TestimonialsContainer = (props: TestimonialsProps) => {

  return (
    <ApolloProvider client={GraphQlClient}>
      <Testimonials {...props} />
    </ApolloProvider>
  );
}

